import React, { useState } from 'react';

import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';

import * as classes from '../../../../components/BobActionMenu.module.css';

const SystemActionMenu = ({
    history,
    ...props
}) => {

    const [menuOpen, setMenuOpen] = useState(false);
    const handleToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const handleClickAway = () => {
        setMenuOpen(false);
    };

    const handleCreateSystem = () => {
        const path = '/v2/dashboard/core/entities/manage';

        const queryValues = queryString.parse(history.location.search);
        queryValues.entityType = 'system';

        const queryValuesString = queryString.stringify(queryValues);
        history.push(`${path}?${queryValuesString}`);
    };

    const renderMenu = () => {
        return <Paper className={classes.BobActionMenu}>
            <Button
                onClick={() => handleCreateSystem()}
            >
                <span className="material-icons-outlined md-18">
                    add
                </span>
                <span className={classes.MenuItemText}>Add New System</span>
            </Button>
            {props.activeNavSite.id ?
                <Button
                    onClick={props.handlePreviewWeatherData}
                >
                    <span className="material-icons-outlined material-icon-size">
                        thermostat
                    </span>
                    <span className={classes.MenuItemText}>Preview Weather Data</span>
                </Button>
                : null
            }
        </Paper>;
    };

    return (
        <ClickAwayListener
            onClickAway={() => handleClickAway()}
        >
            <div>
                <React.Fragment>
                    <Button
                        onClick={handleToggle}
                        className={menuOpen ? classes.BobActionButtonActive : classes.BobActionButton}
                    >
                        Actions
                        <i className={`fas fa-chevron-${menuOpen ? 'up' : 'down'}`} aria-hidden="true" />
                    </Button>
                    {menuOpen ? renderMenu() : null}
                </React.Fragment>
            </div>
        </ClickAwayListener>
    );
};

export default withRouter(SystemActionMenu);
